import { navigate } from "@reach/router";
import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const Cookies = () => {
  const [show, setShow] = useState(false);
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("justact_cookies_enabled");
    if (consent === null) setShow(true);
  }, []);

  const dismiss = (value) => {
    setHiding(true);
    setTimeout(() => {
      localStorage.setItem("justact_cookies_enabled", value);
      setShow(false);
      setHiding(false);
    }, 400);
  };

//hi
  if (!show) return null;

  return (
    <>
      <Backdrop $hiding={hiding} />
      <Wrapper $hiding={hiding}>
        <Card>
          <Content>
            <Description>
              This website will place cookies to help us make this website
              better. To find out more about these cookies, see our{" "}
              <HyperLink onClick={() => navigate("/privacy-policy")}>
                Privacy Policy
              </HyperLink>
              .
            </Description>
          </Content>

          <Divider />

          <Actions>
            <RejectBtn onClick={() => dismiss("false")}>Decline</RejectBtn>
            <AcceptBtn onClick={() => dismiss("true")}>Accept all</AcceptBtn>
          </Actions>

          <CloseBtn onClick={() => dismiss("false")} aria-label="Close">
            ✕
          </CloseBtn>
        </Card>
      </Wrapper>
    </>
  );
};

export default Cookies;

const slideUp = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
`;

const slideDown = keyframes`
  from { transform: translateY(0);    opacity: 1; }
  to   { transform: translateY(120%); opacity: 0; }
`;

const HyperLink = styled.span`
  cursor: pointer;
  color: #00838c;
  text-decoration: underline;
  font-size: 14px;
  font-family: openSans-SemiBold, sans-serif;
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 20, 0.35);
  backdrop-filter: blur(2px);
  z-index: 2147483646;
  animation: ${({ $hiding }) => ($hiding ? slideDown : slideUp)} 0.4s ease
    forwards;

  @media (min-width: 768px) {
    display: none;
  }
`;

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2147483647;
  animation: ${({ $hiding }) => ($hiding ? slideDown : slideUp)} 0.45s
    cubic-bezier(0.22, 1, 0.36, 1) forwards;

  @media (min-width: 1024px) {
    bottom: 28px;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    max-width: 860px;
    min-width: 680px;
    padding: 0 20px;
  }
`;

const Card = styled.div`
  font-family: openSans-SemiBold, sans-serif;
  background: #0d0d14;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 20px;

  /* Tablet */
  @media (max-width: 1023px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 20px 20px 24px;
  }

  /* Mobile */
  @media (max-width: 480px) {
    padding: 18px 16px 22px;
    gap: 14px;
  }

  /* Desktop floating card */
  @media (min-width: 1024px) {
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    box-shadow:
      0 32px 64px rgba(0, 0, 0, 0.55),
      0 0 0 1px rgba(99, 102, 241, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
    padding: 22px 28px;
    background: linear-gradient(135deg, #0f0f1a 0%, #0d0d14 100%);
  }
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

const Description = styled.p`
  font-size: 13px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.52);
  margin: 0;
  font-family: openSans-Regular, sans-serif;

  a {
    color: #818cf8;
    text-decoration: none;
    border-bottom: 1px solid rgba(129, 140, 248, 0.35);
    transition:
      color 0.2s,
      border-color 0.2s;
    cursor: pointer;

    &:hover {
      color: #a5b4fc;
      border-color: rgba(165, 180, 252, 0.6);
    }
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 1023px) {
    flex-direction: row;
    width: 100%;
  }

  @media (max-width: 360px) {
    flex-direction: column;
    gap: 8px;
  }
`;

const AcceptBtn = styled.button`
  font-size: 13px;
  font-family: openSans-SemiBold, sans-serif;
  letter-spacing: 0.3px;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  background: #00838c;
  background-size: 200% auto;
  transition:
    background-position 0.4s,
    transform 0.15s,
    box-shadow 0.2s;

  &:hover {
    background-position: right center;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 1023px) {
    flex: 1;
    text-align: center;
  }

  @media (max-width: 360px) {
    width: 100%;
  }
`;

const RejectBtn = styled.button`
  font-family: openSans-SemiBold, sans-serif;
  font-size: 13px;
  letter-spacing: 0.2px;
  color: rgba(255, 255, 255, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 12px 20px;
  cursor: pointer;
  white-space: nowrap;
  background: transparent;
  transition:
    color 0.2s,
    border-color 0.2s,
    background 0.2s,
    transform 0.15s;

  &:hover {
    color: rgba(255, 255, 255, 0.75);
    border-color: rgba(255, 255, 255, 0.22);
    background: rgba(255, 255, 255, 0.05);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 1023px) {
    flex: 0.6;
    text-align: center;
  }

  @media (max-width: 360px) {
    width: 100%;
  }
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background 0.2s,
    color 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.13);
    color: rgba(255, 255, 255, 0.75);
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

const Divider = styled.div`
  width: 1px;
  height: 36px;
  background: rgba(255, 255, 255, 0.08);
  flex-shrink: 0;

  @media (max-width: 1023px) {
    display: none;
  }
`;
